(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-atc-sticky"] && !Shopify.designMode) return;
  try {
    
(function () {
  const bar = document.getElementById('az-sticky-atc');
  if (!bar) return;

  document.body.classList.add('az-sticky-atc--active');

  const btn = bar.querySelector('#az-sticky-atc-btn');
  const priceEl = bar.querySelector('.az-sticky-atc__btn-price');
  const prices = JSON.parse(bar.querySelector('[data-az-sticky-prices]').textContent);

  // Variante elegida en la ficha (Dawn actualiza este input al cambiar de opción; vacío = combinación no disponible)
  const selectedVariantId = () => {
    const input = document.querySelector('product-form .product-variant-id, form.installment input[name="id"]');
    return input ? input.value : bar.dataset.variantId;
  };

  document.addEventListener('change', (event) => {
    if (event.target.name !== 'id') return;
    const price = prices[selectedVariantId()];
    if (price) priceEl.textContent = price;
  });

  btn.addEventListener('click', () => {
    if (btn.getAttribute('aria-disabled') === 'true') return;

    const variantId = selectedVariantId();
    if (!variantId) return;
    btn.setAttribute('aria-disabled', 'true');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (cart) {
      body.append('sections', cart.getSectionsToRender().map((section) => section.id));
      body.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = body;

    fetch(routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.errors || response.description);
          return;
        }
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        cart.renderContents(response);
      })
      .catch((e) => console.error(e))
      .finally(() => btn.removeAttribute('aria-disabled'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-cart-shipping"] && !Shopify.designMode) return;
  try {
    
  /*
    <az-cart-live>: la barra de envío gratis y las sugerencias.
    Está igual en az-cart-shipping y en az-suggestions (se define una sola vez, gana la que carga primero):
    si se cambia, hay que cambiarla igual en las dos.
    - Cuando cambia el carrito (aviso «cart-update» de Dawn), vuelve a pedir su sección y se repinta.
    - Sugerencias: añaden sin recargar, en el carrito y en las fichas. En el carrito se repinta lo mismo que
      repinta Dawn al cambiar una cantidad (artículos, total y número del carrito), más la barra y las sugerencias.
    Nunca publica «cart-update» (eso despertó el bucle de Quantity X en septiembre).
  */
  if (!customElements.get('az-cart-live')) {
    const azWait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const azCalm = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const azParse = (html) => new DOMParser().parseFromString(html, 'text/html');
    const AZ_CHECK =
      '<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    class AzCartLive extends HTMLElement {
      static toastTimer = null;
      #unsubscribe = null;
      #controller = null;

      connectedCallback() {
        this.#listen();
        if (!this.#unsubscribe) {
          document.addEventListener('DOMContentLoaded', () => this.#listen(), { once: true });
        }
        this.#animateFill(0);
        this.addEventListener('submit', this.#onSubmit);
        this.addEventListener('change', this.#onSize);
        window.addEventListener('pageshow', this.#onPageShow);
        if (this.dataset.modo) AzCartLive.toast();
      }

      disconnectedCallback() {
        this.#unsubscribe?.();
        this.#unsubscribe = null;
        window.removeEventListener('pageshow', this.#onPageShow);
      }

      #listen() {
        if (this.#unsubscribe) return;
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.#unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }

      async refresh() {
        this.#controller?.abort();
        this.#controller = new AbortController();

        try {
          const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(this.dataset.sectionId)}`, {
            signal: this.#controller.signal,
          });
          if (response.ok) this.paint(await response.text());
        } catch (error) {
          if (error.name !== 'AbortError') console.error(error);
        }
      }

      /* Repinta con el HTML nuevo de su sección: la barra crece desde donde estaba y las tarjetas nuevas entran */
      paint(text) {
        const fresh = azParse(text).querySelector('az-cart-live');
        if (!fresh) return;

        const fill = this.querySelector('[data-az-fill]')?.style.width;
        const message = this.querySelector('.az-cfs__msg')?.textContent.trim();
        const wasOk = Boolean(this.querySelector('.az-cfs__box--ok'));
        const shown = new Set(Array.from(this.querySelectorAll('[data-az-product]'), (item) => item.dataset.azProduct));

        this.innerHTML = fresh.innerHTML;
        this.hidden = fresh.hidden;

        if (fill) this.#animateFill(fill);
        const newMessage = this.querySelector('.az-cfs__msg');
        if (newMessage && message !== undefined && newMessage.textContent.trim() !== message) {
          newMessage.classList.add('is-new');
        }
        if (!wasOk) this.querySelector('.az-cfs__box--ok')?.classList.add('is-unlocked');

        let delay = 0;
        for (const item of this.querySelectorAll('[data-az-product]')) {
          if (shown.has(item.dataset.azProduct)) continue;
          item.classList.add('is-entering');
          item.style.setProperty('--az-sug-delay', `${delay}ms`);
          delay += 80;
        }
      }

      /* La barra crece desde «from» hasta el valor que trae el HTML */
      #animateFill(from) {
        const fill = this.querySelector('[data-az-fill]');
        if (!fill) return;
        const target = fill.style.width;
        fill.style.width = typeof from === 'number' ? `${from}%` : from;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            fill.style.width = target;
          });
        });
      }

      /* Tamaños: al elegir otro cambian el precio, el tachado, «Portes grátis» y los enlaces */
      #onSize = (event) => {
        const input = event.target;
        if (!input.classList?.contains('az-sug__tamano-input')) return;
        const form = input.form;
        const price = form.querySelector('[data-az-precio]');
        const before = form.querySelector('[data-az-antes]');
        const chip = form.querySelector('[data-az-chip]');
        if (price) price.textContent = input.dataset.precio;
        if (before) {
          before.textContent = input.dataset.antes;
          before.hidden = !input.dataset.antes;
        }
        if (chip) chip.hidden = input.dataset.llega !== '1';
        for (const link of form.querySelectorAll('.az-sug__media, .az-sug__nombre')) link.href = input.dataset.url;
      };

      /* Cada sugerencia es un formulario con dos botones (el «+» de la foto y «Adicionar» de la lista del móvil) */
      #onSubmit = (event) => {
        const form = event.target;
        if (!form.classList?.contains('az-sug__form')) return;
        event.preventDefault();
        if (form.dataset.azBusy) return;
        form.dataset.azBusy = 'true';
        this.#add(form, event.submitter || form.querySelector('[type="submit"]'));
      };

      /* Añade 1 unidad con la API del carrito y repinta sin recargar la página */
      async #add(form, button) {
        const item = form.closest('.az-sug__item');
        const buttons = form.querySelectorAll('[type="submit"]');
        const variantId = new FormData(form).get('id');
        for (const b of buttons) b.setAttribute('aria-disabled', 'true');
        button?.classList.add('is-loading');

        const targets = this.#targets();
        const body = new FormData(form);
        body.append('sections', targets.slice(0, 5).map((target) => target.section).join(','));
        body.append('sections_url', window.location.pathname);

        let data = null;
        try {
          const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          });
          data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || response.statusText);
        } catch (error) {
          console.error(error);
          button?.classList.remove('is-loading');
          for (const b of buttons) b.removeAttribute('aria-disabled');
          delete form.dataset.azBusy;
          AzCartLive.toast({ error: data?.description || this.dataset.textoError });
          return;
        }

        button?.classList.remove('is-loading');
        for (const b of buttons) b.classList.add('is-added');
        item?.classList.add('is-done');

        const name = form.querySelector('.az-sug__nombre')?.textContent.trim() || data.product_title;
        const size = form.querySelector('.az-sug__tamano-input:checked + .az-sug__tamano, .az-sug__tamano-txt');
        AzCartLive.toast({
          title: this.dataset.textoAnadido,
          name: size ? `${name} · ${size.textContent.trim()}` : name,
          image: form.querySelector('.az-sug__img')?.currentSrc || data.image,
          color: getComputedStyle(this).getPropertyValue('--az-sug-color').trim(),
          link: this.dataset.modo === 'ficha' ? { href: this.dataset.cartUrl, text: this.dataset.textoCarrito } : null,
        });

        if (!azCalm()) {
          await azWait(this.dataset.modo === 'ficha' ? 1100 : 650);
          item?.classList.add('is-leaving');
          await azWait(260);
        }

        try {
          this.#paintTargets(targets, data.sections || {}, variantId);
        } catch (error) {
          console.error(error);
          if (this.dataset.modo !== 'ficha') window.location.reload();
        }

        if (form.isConnected) {
          item?.classList.remove('is-done', 'is-leaving');
          for (const b of buttons) {
            b.classList.remove('is-added');
            b.removeAttribute('aria-disabled');
          }
          delete form.dataset.azBusy;
        }
      }

      /*
        Qué se repinta. En el carrito, lo mismo que Dawn al cambiar una cantidad, más cada <az-cart-live>;
        en la ficha, el número del carrito y estas sugerencias. Shopify devuelve como mucho 5 secciones:
        las que no caben se piden aparte.
      */
      #targets() {
        const targets = [];
        if (this.dataset.modo !== 'ficha') {
          for (const id of ['main-cart-items', 'main-cart-footer']) {
            const element = document.getElementById(id);
            if (element?.dataset.id) targets.push({ id, section: element.dataset.id, selector: '.js-contents' });
          }
        }
        if (document.getElementById('cart-icon-bubble')) {
          targets.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
        }
        const lives = this.dataset.modo === 'ficha' ? [this] : document.querySelectorAll('az-cart-live[data-section-id]');
        for (const live of lives) targets.push({ live, section: live.dataset.sectionId });
        return targets;
      }

      #paintTargets(targets, sections, variantId) {
        const top = this.getBoundingClientRect().top;
        for (const target of targets) {
          const html = sections[target.section];
          if (target.live) {
            if (html) target.live.paint(html);
            else target.live.refresh();
            continue;
          }
          const element = document.getElementById(target.id);
          const source = html && azParse(html).querySelector(target.selector);
          if (!element || !source) continue;
          (element.querySelector(target.selector) || element).innerHTML = source.innerHTML;
        }

        if (this.dataset.modo === 'ficha') return;
        document.querySelector('cart-items')?.classList.remove('is-empty');
        document.getElementById('main-cart-footer')?.classList.remove('is-empty');
        /* La línea nueva entra arriba: se compensa el scroll para que las sugerencias no salten */
        const shift = this.hidden ? 0 : this.getBoundingClientRect().top - top;
        if (Math.abs(shift) > 1) window.scrollBy(0, shift);
        if (variantId && !azCalm()) {
          const link = document.querySelector(`#main-cart-items .cart-item a[href*="variant=${variantId}"]`);
          link?.closest('.cart-item')?.classList.add('az-sug-nuevo');
        }
        if (!this.contains(document.activeElement)) this.querySelector('.az-sug__titulo')?.focus({ preventScroll: true });
      }

      /* Aviso flotante «Adicionado» (uno para toda la página; los lectores de pantalla también lo leen) */
      static toast(options) {
        let toast = document.querySelector('.az-sug-toast');
        if (!toast) {
          toast = document.createElement('div');
          toast.className = 'az-sug-toast';
          toast.setAttribute('role', 'status');
          toast.setAttribute('aria-live', 'polite');
          document.body.append(toast);
        }
        if (!options) return;

        clearTimeout(AzCartLive.toastTimer);
        toast.classList.toggle('az-sug-toast--error', Boolean(options.error));
        if (options.color) toast.style.setProperty('--az-sug-color', options.color);
        toast.replaceChildren();

        if (options.image) {
          const image = document.createElement('img');
          image.className = 'az-sug-toast__img';
          image.src = options.image;
          image.alt = '';
          toast.append(image);
        }

        const text = document.createElement('p');
        text.className = 'az-sug-toast__texto';
        const title = document.createElement('strong');
        title.className = 'az-sug-toast__titulo';
        title.textContent = options.error || options.title;
        if (!options.error) title.insertAdjacentHTML('afterbegin', AZ_CHECK);
        text.append(title);
        if (options.name) {
          const name = document.createElement('span');
          name.className = 'az-sug-toast__nombre';
          name.textContent = options.name;
          text.append(name);
        }
        toast.append(text);

        if (options.link?.href && options.link.text) {
          const link = document.createElement('a');
          link.className = 'az-sug-toast__link';
          link.href = options.link.href;
          link.textContent = options.link.text;
          toast.append(link);
        }

        requestAnimationFrame(() => toast.classList.add('is-open'));
        AzCartLive.toastTimer = setTimeout(() => toast.classList.remove('is-open'), options.link ? 6000 : 3500);
      }

      /* Al volver atrás desde otra página, los botones no se quedan bloqueados */
      #onPageShow = () => {
        for (const form of this.querySelectorAll('[data-az-busy]')) {
          delete form.dataset.azBusy;
        }
        for (const element of this.querySelectorAll('.is-loading, .is-added, .is-done, .is-leaving')) {
          element.removeAttribute('aria-disabled');
          element.classList.remove('is-loading', 'is-added', 'is-done', 'is-leaving');
        }
      };
    }

    customElements.define('az-cart-live', AzCartLive);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-comparative"] && !Shopify.designMode) return;
  try {
    
class AzVsBtn extends HTMLElement {
  connectedCallback() {
    this.querySelector('button').addEventListener('click', () => {
      const atc = document.querySelector('.grab_the_deal, .product-form__submit, [name="add"], button[data-add-to-cart]');
      if (!atc) return;
      atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => atc.click(), 500);
    });
  }
}

if (!customElements.get('az-vs-btn')) {
  customElements.define('az-vs-btn', AzVsBtn);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-early-access-thanks"] && !Shopify.designMode) return;
  try {
    
class AzEarlyThanks extends HTMLElement {
  connectedCallback() {
    clearInterval(this.interval);
    this.zone = this.dataset.timezone || 'Europe/Lisbon';
    this.editor = this.dataset.editor === 'true';
    this.daysOnly = this.dataset.days === 'true';
    this.open = this.parse(this.dataset.open);
    // Sin hora («2026-11-26»): evento de día completo y, si se quiere, cuenta atrás en días
    this.allDay = /^\s*(\d{4}-\d{1,2}-\d{1,2}|\d{1,2}\/\d{1,2}\/\d{4})\s*$/.test(this.dataset.open || '');

    const preview = new URLSearchParams(window.location.search).get('az_now');
    const previewTime = preview ? this.parse(preview) : null;
    this.offset = previewTime && !Number.isNaN(previewTime) ? previewTime - Date.now() : 0;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this.querySelectorAll('[data-az-localize]').forEach((link) => {
      link.setAttribute('href', this.localize(link.getAttribute('href'), root));
    });

    this.states = this.querySelectorAll('[data-az-state]');
    this.onlies = this.querySelectorAll('[data-az-only]');
    this.countdown = this.querySelector('[data-az-countdown]');
    this.countdownLabel = this.querySelector('[data-az-countdown-label]');
    this.timer = this.querySelector('[data-az-timer]');
    this.labelKey = null;
    this.calendar = this.querySelector('[data-az-calendar]');
    this.units = {};
    this.querySelectorAll('[data-az-unit]').forEach((element) => {
      this.units[element.dataset.azUnit] = element;
    });

    this.setupCalendar();
    if (this.editor) this.warn();

    this.tick();
    this.interval = setInterval(() => this.tick(), 15000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  localize(url, root) {
    const base = root.replace(/\/$/, '');
    if (!url || !base || !url.startsWith('/') || url.startsWith('//')) return url;
    if (url === base || url.startsWith(`${base}/`) || url.startsWith(`${base}?`)) return url;
    return base + url;
  }

  // «2026-11-25 21:00» o «25/11/2026 21:00», en la hora de la tienda. Vacío: null. Mal escrito: NaN.
  parse(value) {
    const text = (value || '').trim();
    if (!text) return null;
    let match = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2})[:h](\d{2}))?$/);
    let year, month, day, hour, minute;
    if (match) {
      [, year, month, day, hour, minute] = match;
    } else {
      match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ ,]+(\d{1,2})[:h](\d{2}))?$/);
      if (!match) return NaN;
      [, day, month, year, hour, minute] = match;
    }
    [year, month, day] = [year, month, day].map(Number);
    hour = hour !== undefined ? Number(hour) : 0;
    minute = minute !== undefined ? Number(minute) : 0;
    if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return NaN;
    return this.zoned(Date.UTC(year, month - 1, day, hour, minute));
  }

  // Pasa una hora de reloj de la tienda (escrita como si fuera UTC) al instante real.
  zoned(wall) {
    const offset = (time) => {
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: this.zone,
          hourCycle: 'h23',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
        }).formatToParts(new Date(time));
        const get = (type) => Number(parts.find((part) => part.type === type).value);
        const asUtc = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
        return asUtc - Math.floor(time / 1000) * 1000;
      } catch (e) {
        return 0;
      }
    };
    const first = wall - offset(wall);
    return wall - offset(first);
  }

  valid() {
    return this.open !== null && !Number.isNaN(this.open);
  }

  // 20261125T210000Z: el formato de Google Calendar y de los .ics
  stamp(time) {
    return new Date(time).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  }

  // 20261126: día completo. La fecha se toma de la hora de la tienda, no de la de quien la ve.
  dayStamp(time) {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: this.zone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(time));
    const get = (type) => parts.find((part) => part.type === type).value;
    return `${get('year')}${get('month')}${get('day')}`;
  }

  // El día del calendario en la hora de la tienda, como número: para contar días y no horas
  dayNumber(time) {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: this.zone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }).formatToParts(new Date(time));
      const get = (type) => Number(parts.find((part) => part.type === type).value);
      return Math.round(Date.UTC(get('year'), get('month') - 1, get('day')) / 86400000);
    } catch (e) {
      return Math.floor(time / 86400000);
    }
  }

  setupCalendar() {
    if (!this.calendar || !this.valid()) return;
    let start = this.stamp(this.open);
    let end = this.stamp(this.open + 60 * 60 * 1000);
    if (this.allDay) {
      start = this.dayStamp(this.open);
      end = this.dayStamp(this.open + 36 * 60 * 60 * 1000);
    }
    const title = this.dataset.eventTitle || 'Early Access';
    const url = this.dataset.eventUrl || '';
    const text = [this.dataset.eventText, url].filter(Boolean).join('\n\n');

    const google = this.querySelector('[data-az-google]');
    if (google) {
      const params = new URLSearchParams({ action: 'TEMPLATE', text: title, dates: `${start}/${end}`, details: text });
      if (url) params.set('location', url);
      google.href = `https://calendar.google.com/calendar/render?${params.toString()}`;
    }

    // Sin archivo subido, el navegador crea el .ics (con aviso 15 minutos antes)
    const ics = this.querySelector('[data-az-ics]');
    if (ics && !this.dataset.icsUrl) {
      const escape = (value) => value.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
      const lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//LUR//Early Access//PT',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `UID:early-access-${start}@${window.location.hostname}`,
        `DTSTAMP:${this.stamp(Date.now())}`,
        this.allDay ? `DTSTART;VALUE=DATE:${start}` : `DTSTART:${start}`,
        this.allDay ? `DTEND;VALUE=DATE:${end}` : `DTEND:${end}`,
        `SUMMARY:${escape(title)}`,
        `DESCRIPTION:${escape(text)}`,
        url ? `URL:${url}` : '',
        'BEGIN:VALARM',
        // Día completo: aviso a las 9 de la mañana; con hora, 15 minutos antes
        this.allDay ? 'TRIGGER:PT9H' : 'TRIGGER:-PT15M',
        'ACTION:DISPLAY',
        `DESCRIPTION:${escape(title)}`,
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR',
      ].filter(Boolean);
      ics.href = `data:text/calendar;charset=utf-8,${encodeURIComponent(lines.join('\r\n'))}`;
    }
  }

  tick() {
    const now = Date.now() + this.offset;
    const state = this.valid() && now >= this.open ? 'open' : 'before';
    if (state !== this.state) {
      this.state = state;
      this.states.forEach((element) => {
        element.hidden = element.dataset.azState !== state;
      });
      this.onlies.forEach((element) => {
        element.hidden = element.dataset.azOnly !== state;
      });
      if (this.calendar) this.calendar.hidden = state !== 'before' || !this.valid();
    }

    if (!this.countdown) return;
    if (state !== 'before' || !this.valid()) {
      this.countdown.hidden = true;
      return;
    }
    this.countdown.hidden = false;

    // Solo los días que faltan, para no anunciar la hora. El mismo día, el texto de «hoy».
    const pad = (number) => String(number).padStart(2, '0');
    let texts;
    let today = false;
    if (this.daysOnly) {
      const days = this.dayNumber(this.open) - this.dayNumber(now);
      today = days <= 0;
      texts = { d: String(Math.max(0, days)) };
    } else {
      const totalMinutes = Math.max(0, Math.ceil((this.open - now) / 60000));
      texts = {
        d: pad(Math.floor(totalMinutes / 1440)),
        h: pad(Math.floor((totalMinutes % 1440) / 60)),
        m: pad(totalMinutes % 60),
      };
    }

    this.setLabel(today && this.countdownLabel?.dataset.today ? 'today' : 'before');
    if (this.timer) this.timer.hidden = today;

    Object.entries(this.units).forEach(([unit, element]) => {
      const box = element.closest('.az-eat__unit');
      if (box) box.hidden = !(unit in texts);
      const text = texts[unit];
      if (text === undefined) return;
      if (element.textContent !== text) element.textContent = text;
      const label = box && box.querySelector('.az-eat__unit-label');
      if (label) {
        const word = Number(text) === 1 && label.dataset.one ? label.dataset.one : label.dataset.many;
        if (word && label.textContent !== word) label.textContent = word;
      }
    });
  }

  setLabel(key) {
    if (!this.countdownLabel || key === this.labelKey) return;
    this.labelKey = key;
    const label = this.countdownLabel.dataset[key];
    this.countdownLabel.textContent = label || '';
    this.countdownLabel.hidden = !label;
  }

  warn() {
    let text = '';
    if (Number.isNaN(this.open)) {
      text = 'La fecha está mal escrita: escríbela como 2026-11-26 o 2026-11-26 10:00.';
    } else if (this.allDay) {
      text = '«Abre el Early Access» no tiene hora: el evento del calendario es de día completo y a las 00:00 sale «acceso abierto». Pon la hora en cuanto la sepáis.';
    }
    if (!text) return;
    const note = document.createElement('p');
    note.className = 'az-eat__note-editor';
    note.textContent = text;
    this.prepend(note);
  }
}

if (!customElements.get('az-early-thanks')) {
  customElements.define('az-early-thanks', AzEarlyThanks);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-early-access"] && !Shopify.designMode) return;
  try {
    
class AzEarlyAccess extends HTMLElement {
  connectedCallback() {
    clearInterval(this.interval);
    this.zone = this.dataset.timezone || 'Europe/Lisbon';
    this.editor = this.dataset.editor === 'true';
    this.daysOnly = this.dataset.days === 'true';
    this.open = this.parse(this.dataset.open);
    this.public = this.parse(this.dataset.public);
    this.end = this.parse(this.dataset.end);

    const preview = new URLSearchParams(window.location.search).get('az_now');
    const previewTime = preview ? this.parse(preview) : null;
    this.offset = previewTime && !Number.isNaN(previewTime) ? previewTime - Date.now() : 0;

    // Enlaces y página de gracias en el idioma de quien la ve (/es/pages/...), sin duplicar el prefijo
    this.querySelectorAll('[data-az-localize]').forEach((link) => {
      link.setAttribute('href', this.localize(link.getAttribute('href')));
    });
    this.redirect = this.localize(this.dataset.redirect || '');

    this.states = this.querySelectorAll('[data-az-state]');
    this.onlies = this.querySelectorAll('[data-az-only]');
    // Lo que se esconde antes del final (la escalera del Early Access, cuando bajan los descuentos)
    this.untils = [...this.querySelectorAll('[data-az-until]')].map((element) => [element, this.parse(element.dataset.azUntil)]);
    this.countdown = this.querySelector('[data-az-countdown]');
    this.countdownLabel = this.querySelector('[data-az-countdown-label]');
    this.timer = this.querySelector('[data-az-timer]');
    this.labelKey = null;
    this.sticky = this.querySelector('[data-az-sticky]');
    this.units = {};
    this.querySelectorAll('[data-az-unit]').forEach((element) => {
      this.units[element.dataset.azUnit] = element;
    });

    this.forms = [...this.querySelectorAll('form.az-ea__form')];
    this.forms.forEach((form) => {
      if (form.dataset.azReady) return;
      form.dataset.azReady = 'true';
      form.addEventListener('submit', (event) => this.submit(event, form));
    });

    this.querySelectorAll('[data-az-jump]').forEach((link) => {
      if (link.dataset.azReady) return;
      link.dataset.azReady = 'true';
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.jumpTo(link.getAttribute('href'));
      });
    });

    this.setupCarousels();
    this.setupSticky();

    // Testimonios en vídeo: el botón del centro arranca el vídeo y a partir de ahí salen los controles
    this.querySelectorAll('[data-az-play]').forEach((button) => {
      if (button.dataset.azReady) return;
      button.dataset.azReady = 'true';
      const video = button.parentElement.querySelector('video');
      if (!video) return;
      button.addEventListener('click', () => {
        video.controls = true;
        button.hidden = true;
        video.play();
      });
    });

    // Un vídeo a la vez: al dar al play, se paran los demás
    if (!this.dataset.azVideos) {
      this.dataset.azVideos = 'true';
      this.addEventListener('play', (event) => {
        this.querySelectorAll('video').forEach((video) => {
          if (video !== event.target && !video.paused) video.pause();
        });
      }, true);
    }

    if (this.querySelector('[data-az-ea-success]')) this.afterNativeSignup();

    this.tick();
    this.interval = setInterval(() => this.tick(), 15000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    if (this.observer) this.observer.disconnect();
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  }

  localize(url) {
    const root = (this.dataset.root || '/').replace(/\/$/, '');
    if (!url || !root || !url.startsWith('/') || url.startsWith('//')) return url;
    if (url === root || url.startsWith(`${root}/`) || url.startsWith(`${root}?`)) return url;
    return root + url;
  }

  // «2026-11-25 21:00» o «25/11/2026 21:00», en la hora de la tienda. Vacío: null. Mal escrito: NaN.
  parse(value) {
    const text = (value || '').trim();
    if (!text) return null;
    let match = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2})[:h](\d{2}))?$/);
    let year, month, day, hour, minute;
    if (match) {
      [, year, month, day, hour, minute] = match;
    } else {
      match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ ,]+(\d{1,2})[:h](\d{2}))?$/);
      if (!match) return NaN;
      [, day, month, year, hour, minute] = match;
    }
    [year, month, day] = [year, month, day].map(Number);
    hour = hour !== undefined ? Number(hour) : 0;
    minute = minute !== undefined ? Number(minute) : 0;
    if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return NaN;
    return this.zoned(Date.UTC(year, month - 1, day, hour, minute));
  }

  // Pasa una hora de reloj de la tienda (escrita como si fuera UTC) al instante real.
  zoned(wall) {
    const offset = (time) => {
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: this.zone,
          hourCycle: 'h23',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
        }).formatToParts(new Date(time));
        const get = (type) => Number(parts.find((part) => part.type === type).value);
        const asUtc = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
        return asUtc - Math.floor(time / 1000) * 1000;
      } catch (e) {
        return 0;
      }
    };
    const first = wall - offset(wall);
    return wall - offset(first);
  }

  valid(time) {
    return typeof time === 'number' && !Number.isNaN(time);
  }

  stateAt(now) {
    if (this.valid(this.end) && now >= this.end) return 'ended';
    if (this.valid(this.public) && now >= this.public) return 'public';
    if (this.valid(this.open) && now >= this.open) return 'open';
    return 'signup';
  }

  tick() {
    const now = Date.now() + this.offset;
    const state = this.stateAt(now);

    if (state !== this.state) {
      this.state = state;
      this.states.forEach((element) => {
        element.hidden = element.dataset.azState !== state;
      });
      this.onlies.forEach((element) => {
        element.hidden = element.dataset.azOnly !== state;
      });
      if (this.editor) this.warn(now);
      this.updateSticky();
    }

    this.untils.forEach(([element, time]) => {
      const gone = this.valid(time) && now >= time;
      if (element.hidden !== gone) element.hidden = gone;
    });

    const target = { signup: this.open, open: this.public, public: this.end }[state];
    if (!this.countdown) return;
    if (!this.valid(target)) {
      this.countdown.hidden = true;
      return;
    }
    this.countdown.hidden = false;

    // Antes de abrir, solo los días que faltan, para no anunciar la hora. El mismo día, el texto de «hoy».
    const daysOnly = state === 'signup' && this.daysOnly;
    const pad = (number) => String(number).padStart(2, '0');
    let texts;
    let today = false;
    if (daysOnly) {
      const days = this.dayNumber(target) - this.dayNumber(now);
      today = days <= 0;
      texts = { d: String(Math.max(0, days)) };
    } else {
      // Redondea hacia arriba al minuto: a las 20:59:30 dice «1 min», no «0»
      const totalMinutes = Math.max(0, Math.ceil((target - now) / 60000));
      texts = {
        d: pad(Math.floor(totalMinutes / 1440)),
        h: pad(Math.floor((totalMinutes % 1440) / 60)),
        m: pad(totalMinutes % 60),
      };
    }

    this.setLabel(today && this.countdownLabel?.dataset.today ? 'today' : state);
    if (this.timer) this.timer.hidden = today;

    Object.entries(this.units).forEach(([unit, element]) => {
      const box = element.closest('.az-ea__unit');
      if (box) box.hidden = !(unit in texts);
      const text = texts[unit];
      if (text === undefined) return;
      if (element.textContent !== text) element.textContent = text;
      const label = box && box.querySelector('.az-ea__unit-label');
      if (label) {
        const word = Number(text) === 1 && label.dataset.one ? label.dataset.one : label.dataset.many;
        if (word && label.textContent !== word) label.textContent = word;
      }
    });
  }

  setLabel(key) {
    if (!this.countdownLabel || key === this.labelKey) return;
    this.labelKey = key;
    const label = this.countdownLabel.dataset[key];
    this.countdownLabel.textContent = label || '';
    this.countdownLabel.hidden = !label;
  }

  // El día del calendario en la hora de la tienda, como número: para contar días y no horas
  dayNumber(time) {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: this.zone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }).formatToParts(new Date(time));
      const get = (type) => Number(parts.find((part) => part.type === type).value);
      return Math.round(Date.UTC(get('year'), get('month') - 1, get('day')) / 86400000);
    } catch (e) {
      return Math.floor(time / 86400000);
    }
  }

  // Solo en el editor: qué estado se ve ahora y si alguna fecha está mal escrita
  warn(now) {
    const old = this.querySelector('.az-ea__note-editor');
    if (old) old.remove();
    const names = { signup: 'inscripción', open: 'acceso abierto', public: 'Black Friday abierta', ended: 'terminada' };
    let text = `Ahora se ve el estado «${names[this.stateAt(now)]}». Para ver otro: ?az_now=2026-11-26%2010:30 en la dirección.`;
    if ([this.open, this.public, this.end].some((time) => Number.isNaN(time))) {
      text = 'Hay una fecha mal escrita: escríbela como 2026-11-26 o 2026-11-26 10:00.';
    } else if (this.valid(this.open) && !/\d[:h]\d{2}$/.test((this.dataset.open || '').trim())) {
      text += ' «Abre el Early Access» no tiene hora: a las 00:00 de ese día la página pasa a «acceso abierto». Pon la hora en cuanto la sepáis.';
    }
    const note = document.createElement('p');
    note.className = 'az-ea__note-editor';
    note.textContent = text;
    this.prepend(note);
  }

  jumpTo(hash) {
    const form = hash ? this.querySelector(hash) : null;
    const card = form ? form.closest('[data-az-form-card]') || form : this.querySelector('[data-az-form-card]');
    if (!card) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    const field = card.querySelector('.az-ea__input');
    if (field) field.focus({ preventScroll: true });
  }

  // Flechas de los carruseles: avanzan una tarjeta y se apagan en los extremos
  setupCarousels() {
    this.querySelectorAll('[data-az-track]').forEach((track) => {
      const band = track.closest('.az-ea__band');
      const prev = band && band.querySelector('[data-az-prev]');
      const next = band && band.querySelector('[data-az-next]');
      if (!prev || !next || track.dataset.azReady) return;
      track.dataset.azReady = 'true';
      const step = () => {
        const item = track.firstElementChild;
        return item ? item.getBoundingClientRect().width + 12 : track.clientWidth;
      };
      const update = () => {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        const arrows = prev.parentElement;
        if (arrows) arrows.hidden = track.scrollWidth <= track.clientWidth + 4;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // Barra fija: sale cuando no se ve ni el botón de la cabecera ni ningún formulario, y no pasa del final de la sección
  setupSticky() {
    if (!this.sticky || this.editor) return;
    this.watched = new Map();
    const targets = [...this.querySelectorAll('[data-az-cta], [data-az-form-card]')];
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => this.watched.set(entry.target, entry.isIntersecting));
        this.updateSticky();
      });
      targets.forEach((target) => this.observer.observe(target));
    }
    this.onScroll = () => {
      if (this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.updateSticky();
      });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  updateSticky() {
    if (!this.sticky || this.editor || !this.watched) return;
    const anyVisible = [...this.watched.values()].some(Boolean);
    const rect = this.getBoundingClientRect();
    const pastEnd = rect.bottom < window.innerHeight;
    const scrolled = window.scrollY > 120;
    this.sticky.hidden = this.state !== 'signup' || anyVisible || pastEnd || !scrolled;
  }

  showError(form, text) {
    const error = form.querySelector('.az-ea__error');
    const email = form.querySelector('input[type="email"]');
    if (error) {
      error.textContent = text;
      error.hidden = !text;
    }
    if (email) {
      if (text) email.setAttribute('aria-invalid', 'true');
      else email.removeAttribute('aria-invalid');
    }
  }

  busy(form, on) {
    const button = form.querySelector('button[type="submit"]');
    const label = button && button.querySelector('[data-az-label]');
    if (!button || !label) return;
    if (on) {
      form.azButtonText = label.textContent;
      label.textContent = this.dataset.sending || form.azButtonText;
      button.disabled = true;
    } else {
      label.textContent = form.azButtonText || label.textContent;
      button.disabled = false;
    }
  }

  // Alta directa en la lista de Klaviyo. Si no hay lista o Klaviyo falla, se envía el formulario nativo de Shopify.
  async submit(event, form) {
    if (form.dataset.azNative === 'true') return;
    event.preventDefault();

    const emailField = form.querySelector('input[type="email"]');
    const email = (emailField?.value || '').trim();
    const name = (form.querySelector('input[name="contact[first_name]"]')?.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      this.showError(form, this.dataset.errorEmail || '');
      emailField?.focus();
      return;
    }
    this.showError(form, '');

    // Un robot rellenó la trampa: se le trata como si hubiera ido bien, sin enviar nada
    if (form.querySelector('[name="az_web"]')?.value) {
      this.done(form);
      return;
    }

    // En el editor no se envía nada: solo se enseña el mensaje de después
    if (this.editor) {
      this.done(form);
      return;
    }

    const key = this.dataset.key;
    const list = this.dataset.list;
    if (!key || !list) {
      this.native(form);
      return;
    }

    this.busy(form, true);
    const params = new URLSearchParams(window.location.search);
    const properties = { idioma: this.dataset.idioma || '' };
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach((param) => {
      if (params.get(param)) properties[`early_access_${param}`] = params.get(param);
    });
    const attributes = { email, properties };
    if (name) attributes.first_name = name;

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(key)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: this.dataset.source || 'Early Access',
              profile: { data: { type: 'profile', attributes } },
            },
            relationships: { list: { data: { type: 'list', id: list } } },
          },
        }),
      });
      if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
      this.done(form);
    } catch (error) {
      console.warn('[az-early-access] Klaviyo no respondió; se envía el formulario de Shopify.', error);
      this.native(form);
    }
  }

  native(form) {
    form.dataset.azNative = 'true';
    this.busy(form, true);
    HTMLFormElement.prototype.submit.call(form);
  }

  done(form) {
    if (this.redirect) {
      window.location.assign(this.redirect);
      return;
    }
    // Sin página de gracias: mensaje en el sitio del formulario
    this.busy(form, false);
    const success = this.querySelector('[data-az-success-template]');
    if (!success) return;
    const card = form.closest('[data-az-form-card]');
    form.replaceWith(success.content.cloneNode(true));
    const trust = card && card.querySelector('[data-az-after-form]');
    if (trust) trust.hidden = true;
  }

  // Tras el envío nativo, Shopify vuelve con ?customer_posted=true#<id del formulario> (el pie también tiene uno)
  afterNativeSignup() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('customer_posted')) return;
    const hash = url.hash.slice(1);
    const ours = this.forms.some((form) => form.id === hash) || [...this.querySelectorAll('[data-az-ea-success]')].some((el) => el.closest('form')?.id === hash);
    if (hash && !ours) return;
    if (this.redirect) {
      window.location.replace(this.redirect);
      return;
    }
    url.searchParams.delete('customer_posted');
    history.replaceState(history.state, '', url.href);
  }
}

if (!customElements.get('az-early-access')) {
  customElements.define('az-early-access', AzEarlyAccess);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-estadistica-V1"] && !Shopify.designMode) return;
  try {
    
(function() {
  var animado = new Set();

  function animarContador(el) {
    if (animado.has(el)) return;
    animado.add(el);
    var objetivo = parseFloat(el.dataset.target);
    var sufijo = el.dataset.sufijo || '';
    var esDecimal = el.dataset.decimal === 'true';
    var duracion = 1200;
    var pasos = 40;
    var actual = 0;
    var incremento = objetivo / pasos;
    var intervalo = setInterval(function() {
      actual += incremento;
      if (actual >= objetivo) {
        actual = objetivo;
        clearInterval(intervalo);
      }
      el.textContent = (esDecimal ? actual.toFixed(2).replace('.', ',') : Math.round(actual)) + sufijo;
    }, duracion / pasos);
  }

  var contadores = document.querySelectorAll('.stats-contador');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animarContador(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  contadores.forEach(function(el) { observer.observe(el); });

  var interior = document.querySelector('.stats-interior');
  var dotsWrapper = document.querySelector('.stats-dots');
  if (!interior || !dotsWrapper) return;

  var celdas = interior.querySelectorAll('.stats-celda');
  var dots = [];

  celdas.forEach(function(_, i) {
    var dot = document.createElement('button');
    dot.className = 'stats-dot' + (i === 0 ? ' activo' : '');
    dot.setAttribute('aria-label', 'Estadística ' + (i + 1));
    dot.addEventListener('click', function() {
      interior.scrollTo({ left: interior.offsetWidth * i, behavior: 'smooth' });
    });
    dotsWrapper.appendChild(dot);
    dots.push(dot);
  });

  interior.addEventListener('scroll', function() {
    var indice = Math.round(interior.scrollLeft / interior.offsetWidth);
    dots.forEach(function(dot, i) {
      dot.classList.toggle('activo', i === indice);
    });
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-guide-signup"] && !Shopify.designMode) return;
  try {
    
class AzGuideSignup extends HTMLElement {
  connectedCallback() {
    for (const link of this.querySelectorAll('[data-az-gs-jump]')) {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.#jumpToForm();
      });
    }

    const success = this.querySelector('[data-az-gs-success]');
    if (success) this.#afterSignup(success);
  }

  // El botón final sube al formulario y deja el cursor en el email.
  #jumpToForm() {
    const wrap = this.querySelector('.az-gs__form-wrap');
    if (!wrap) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    wrap.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    const field = wrap.querySelector('input:not([type="hidden"])');
    if (field) field.focus({ preventScroll: true });
  }

  // Solo justo después de enviar ESTE formulario (el pie también tiene un formulario de cliente).
  #afterSignup(success) {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('customer_posted')) return;

    const formId = this.querySelector('form')?.id;
    const hash = url.hash.slice(1);
    if (hash && formId && hash !== formId) return;

    const redirect = success.dataset.redirect;
    if (redirect) {
      window.location.replace(redirect);
      return;
    }

    // Quita ?customer_posted=true para que recargar no vuelva a enseñar el mensaje.
    url.searchParams.delete('customer_posted');
    history.replaceState(history.state, '', url.href);
  }
}

if (!customElements.get('az-guide-signup')) {
  customElements.define('az-guide-signup', AzGuideSignup);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-midpage-cta"] && !Shopify.designMode) return;
  try {
    
class AzCtaButton extends HTMLElement {
  connectedCallback() {
    this.querySelector('button').addEventListener('click', () => {
      const atc = document.querySelector('.grab_the_deal, .product-form__submit, [name="add"], button[data-add-to-cart]');
      if (!atc) return;
      atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => atc.click(), 500);
    });
  }
}

if (!customElements.get('az-cta-button')) {
  customElements.define('az-cta-button', AzCtaButton);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-stats"] && !Shopify.designMode) return;
  try {
    
class AzStatsCount extends HTMLElement {
  #observer = null;

  connectedCallback() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.#startCount();
          this.#observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #startCount() {
    const target = parseFloat(this.dataset.target);
    const suffix = this.dataset.suffix || '';
    const isDecimal = this.dataset.target.includes('.');
    const duration = 1400;
    let start = null;

    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;
      this.textContent = (isDecimal
        ? current.toFixed(2).replace('.', ',')
        : Math.floor(current)) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        this.textContent = (isDecimal ? String(target).replace('.', ',') : String(target)) + suffix;
      }
    };

    requestAnimationFrame(step);
  }
}

if (!customElements.get('az-stats-count')) {
  customElements.define('az-stats-count', AzStatsCount);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-suggestions"] && !Shopify.designMode) return;
  try {
    
  /*
    <az-cart-live>: la barra de envío gratis y las sugerencias.
    Está igual en az-cart-shipping y en az-suggestions (se define una sola vez, gana la que carga primero):
    si se cambia, hay que cambiarla igual en las dos.
    - Cuando cambia el carrito (aviso «cart-update» de Dawn), vuelve a pedir su sección y se repinta.
    - Sugerencias: añaden sin recargar, en el carrito y en las fichas. En el carrito se repinta lo mismo que
      repinta Dawn al cambiar una cantidad (artículos, total y número del carrito), más la barra y las sugerencias.
    Nunca publica «cart-update» (eso despertó el bucle de Quantity X en septiembre).
  */
  if (!customElements.get('az-cart-live')) {
    const azWait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const azCalm = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const azParse = (html) => new DOMParser().parseFromString(html, 'text/html');
    const AZ_CHECK =
      '<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    class AzCartLive extends HTMLElement {
      static toastTimer = null;
      #unsubscribe = null;
      #controller = null;

      connectedCallback() {
        this.#listen();
        if (!this.#unsubscribe) {
          document.addEventListener('DOMContentLoaded', () => this.#listen(), { once: true });
        }
        this.#animateFill(0);
        this.addEventListener('submit', this.#onSubmit);
        this.addEventListener('change', this.#onSize);
        window.addEventListener('pageshow', this.#onPageShow);
        if (this.dataset.modo) AzCartLive.toast();
      }

      disconnectedCallback() {
        this.#unsubscribe?.();
        this.#unsubscribe = null;
        window.removeEventListener('pageshow', this.#onPageShow);
      }

      #listen() {
        if (this.#unsubscribe) return;
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.#unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }

      async refresh() {
        this.#controller?.abort();
        this.#controller = new AbortController();

        try {
          const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(this.dataset.sectionId)}`, {
            signal: this.#controller.signal,
          });
          if (response.ok) this.paint(await response.text());
        } catch (error) {
          if (error.name !== 'AbortError') console.error(error);
        }
      }

      /* Repinta con el HTML nuevo de su sección: la barra crece desde donde estaba y las tarjetas nuevas entran */
      paint(text) {
        const fresh = azParse(text).querySelector('az-cart-live');
        if (!fresh) return;

        const fill = this.querySelector('[data-az-fill]')?.style.width;
        const message = this.querySelector('.az-cfs__msg')?.textContent.trim();
        const wasOk = Boolean(this.querySelector('.az-cfs__box--ok'));
        const shown = new Set(Array.from(this.querySelectorAll('[data-az-product]'), (item) => item.dataset.azProduct));

        this.innerHTML = fresh.innerHTML;
        this.hidden = fresh.hidden;

        if (fill) this.#animateFill(fill);
        const newMessage = this.querySelector('.az-cfs__msg');
        if (newMessage && message !== undefined && newMessage.textContent.trim() !== message) {
          newMessage.classList.add('is-new');
        }
        if (!wasOk) this.querySelector('.az-cfs__box--ok')?.classList.add('is-unlocked');

        let delay = 0;
        for (const item of this.querySelectorAll('[data-az-product]')) {
          if (shown.has(item.dataset.azProduct)) continue;
          item.classList.add('is-entering');
          item.style.setProperty('--az-sug-delay', `${delay}ms`);
          delay += 80;
        }
      }

      /* La barra crece desde «from» hasta el valor que trae el HTML */
      #animateFill(from) {
        const fill = this.querySelector('[data-az-fill]');
        if (!fill) return;
        const target = fill.style.width;
        fill.style.width = typeof from === 'number' ? `${from}%` : from;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            fill.style.width = target;
          });
        });
      }

      /* Tamaños: al elegir otro cambian el precio, el tachado, «Portes grátis» y los enlaces */
      #onSize = (event) => {
        const input = event.target;
        if (!input.classList?.contains('az-sug__tamano-input')) return;
        const form = input.form;
        const price = form.querySelector('[data-az-precio]');
        const before = form.querySelector('[data-az-antes]');
        const chip = form.querySelector('[data-az-chip]');
        if (price) price.textContent = input.dataset.precio;
        if (before) {
          before.textContent = input.dataset.antes;
          before.hidden = !input.dataset.antes;
        }
        if (chip) chip.hidden = input.dataset.llega !== '1';
        for (const link of form.querySelectorAll('.az-sug__media, .az-sug__nombre')) link.href = input.dataset.url;
      };

      /* Cada sugerencia es un formulario con dos botones (el «+» de la foto y «Adicionar» de la lista del móvil) */
      #onSubmit = (event) => {
        const form = event.target;
        if (!form.classList?.contains('az-sug__form')) return;
        event.preventDefault();
        if (form.dataset.azBusy) return;
        form.dataset.azBusy = 'true';
        this.#add(form, event.submitter || form.querySelector('[type="submit"]'));
      };

      /* Añade 1 unidad con la API del carrito y repinta sin recargar la página */
      async #add(form, button) {
        const item = form.closest('.az-sug__item');
        const buttons = form.querySelectorAll('[type="submit"]');
        const variantId = new FormData(form).get('id');
        for (const b of buttons) b.setAttribute('aria-disabled', 'true');
        button?.classList.add('is-loading');

        const targets = this.#targets();
        const body = new FormData(form);
        body.append('sections', targets.slice(0, 5).map((target) => target.section).join(','));
        body.append('sections_url', window.location.pathname);

        let data = null;
        try {
          const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          });
          data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || response.statusText);
        } catch (error) {
          console.error(error);
          button?.classList.remove('is-loading');
          for (const b of buttons) b.removeAttribute('aria-disabled');
          delete form.dataset.azBusy;
          AzCartLive.toast({ error: data?.description || this.dataset.textoError });
          return;
        }

        button?.classList.remove('is-loading');
        for (const b of buttons) b.classList.add('is-added');
        item?.classList.add('is-done');

        const name = form.querySelector('.az-sug__nombre')?.textContent.trim() || data.product_title;
        const size = form.querySelector('.az-sug__tamano-input:checked + .az-sug__tamano, .az-sug__tamano-txt');
        AzCartLive.toast({
          title: this.dataset.textoAnadido,
          name: size ? `${name} · ${size.textContent.trim()}` : name,
          image: form.querySelector('.az-sug__img')?.currentSrc || data.image,
          color: getComputedStyle(this).getPropertyValue('--az-sug-color').trim(),
          link: this.dataset.modo === 'ficha' ? { href: this.dataset.cartUrl, text: this.dataset.textoCarrito } : null,
        });

        if (!azCalm()) {
          await azWait(this.dataset.modo === 'ficha' ? 1100 : 650);
          item?.classList.add('is-leaving');
          await azWait(260);
        }

        try {
          this.#paintTargets(targets, data.sections || {}, variantId);
        } catch (error) {
          console.error(error);
          if (this.dataset.modo !== 'ficha') window.location.reload();
        }

        if (form.isConnected) {
          item?.classList.remove('is-done', 'is-leaving');
          for (const b of buttons) {
            b.classList.remove('is-added');
            b.removeAttribute('aria-disabled');
          }
          delete form.dataset.azBusy;
        }
      }

      /*
        Qué se repinta. En el carrito, lo mismo que Dawn al cambiar una cantidad, más cada <az-cart-live>;
        en la ficha, el número del carrito y estas sugerencias. Shopify devuelve como mucho 5 secciones:
        las que no caben se piden aparte.
      */
      #targets() {
        const targets = [];
        if (this.dataset.modo !== 'ficha') {
          for (const id of ['main-cart-items', 'main-cart-footer']) {
            const element = document.getElementById(id);
            if (element?.dataset.id) targets.push({ id, section: element.dataset.id, selector: '.js-contents' });
          }
        }
        if (document.getElementById('cart-icon-bubble')) {
          targets.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
        }
        const lives = this.dataset.modo === 'ficha' ? [this] : document.querySelectorAll('az-cart-live[data-section-id]');
        for (const live of lives) targets.push({ live, section: live.dataset.sectionId });
        return targets;
      }

      #paintTargets(targets, sections, variantId) {
        const top = this.getBoundingClientRect().top;
        for (const target of targets) {
          const html = sections[target.section];
          if (target.live) {
            if (html) target.live.paint(html);
            else target.live.refresh();
            continue;
          }
          const element = document.getElementById(target.id);
          const source = html && azParse(html).querySelector(target.selector);
          if (!element || !source) continue;
          (element.querySelector(target.selector) || element).innerHTML = source.innerHTML;
        }

        if (this.dataset.modo === 'ficha') return;
        document.querySelector('cart-items')?.classList.remove('is-empty');
        document.getElementById('main-cart-footer')?.classList.remove('is-empty');
        /* La línea nueva entra arriba: se compensa el scroll para que las sugerencias no salten */
        const shift = this.hidden ? 0 : this.getBoundingClientRect().top - top;
        if (Math.abs(shift) > 1) window.scrollBy(0, shift);
        if (variantId && !azCalm()) {
          const link = document.querySelector(`#main-cart-items .cart-item a[href*="variant=${variantId}"]`);
          link?.closest('.cart-item')?.classList.add('az-sug-nuevo');
        }
        if (!this.contains(document.activeElement)) this.querySelector('.az-sug__titulo')?.focus({ preventScroll: true });
      }

      /* Aviso flotante «Adicionado» (uno para toda la página; los lectores de pantalla también lo leen) */
      static toast(options) {
        let toast = document.querySelector('.az-sug-toast');
        if (!toast) {
          toast = document.createElement('div');
          toast.className = 'az-sug-toast';
          toast.setAttribute('role', 'status');
          toast.setAttribute('aria-live', 'polite');
          document.body.append(toast);
        }
        if (!options) return;

        clearTimeout(AzCartLive.toastTimer);
        toast.classList.toggle('az-sug-toast--error', Boolean(options.error));
        if (options.color) toast.style.setProperty('--az-sug-color', options.color);
        toast.replaceChildren();

        if (options.image) {
          const image = document.createElement('img');
          image.className = 'az-sug-toast__img';
          image.src = options.image;
          image.alt = '';
          toast.append(image);
        }

        const text = document.createElement('p');
        text.className = 'az-sug-toast__texto';
        const title = document.createElement('strong');
        title.className = 'az-sug-toast__titulo';
        title.textContent = options.error || options.title;
        if (!options.error) title.insertAdjacentHTML('afterbegin', AZ_CHECK);
        text.append(title);
        if (options.name) {
          const name = document.createElement('span');
          name.className = 'az-sug-toast__nombre';
          name.textContent = options.name;
          text.append(name);
        }
        toast.append(text);

        if (options.link?.href && options.link.text) {
          const link = document.createElement('a');
          link.className = 'az-sug-toast__link';
          link.href = options.link.href;
          link.textContent = options.link.text;
          toast.append(link);
        }

        requestAnimationFrame(() => toast.classList.add('is-open'));
        AzCartLive.toastTimer = setTimeout(() => toast.classList.remove('is-open'), options.link ? 6000 : 3500);
      }

      /* Al volver atrás desde otra página, los botones no se quedan bloqueados */
      #onPageShow = () => {
        for (const form of this.querySelectorAll('[data-az-busy]')) {
          delete form.dataset.azBusy;
        }
        for (const element of this.querySelectorAll('.is-loading, .is-added, .is-done, .is-leaving')) {
          element.removeAttribute('aria-disabled');
          element.classList.remove('is-loading', 'is-added', 'is-done', 'is-leaving');
        }
      };
    }

    customElements.define('az-cart-live', AzCartLive);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-ug"] && !Shopify.designMode) return;
  try {
    
class AzUgcCard extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('[data-dialog]');
    if (!btn) return;

    const dialog = this.querySelector('.az-ugc__dialog');
    if (!dialog) return;

    const closeBtn = dialog.querySelector('.az-ugc__dialog-close');
    const video = dialog.querySelector('video');

    btn.addEventListener('click', () => {
      dialog.showModal();
      video?.play();
    });

    closeBtn?.addEventListener('click', () => {
      this.#closeDialog(dialog, video);
    });

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) this.#closeDialog(dialog, video);
    });

    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.#closeDialog(dialog, video);
    });
  }

  #closeDialog(dialog, video) {
    video?.pause();
    video?.load();
    dialog.close();
  }
}

if (!customElements.get('az-ugc-card')) {
  customElements.define('az-ugc-card', AzUgcCard);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
